
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[year]/[month]/[day]/[slug]",
      function () {
        return require("private-next-pages/blog/[year]/[month]/[day]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[year]/[month]/[day]/[slug]"])
      });
    }
  